
<template>
    <div class="container containerBox">
        <!-- 头部筛选区 -->
        <div class="handle-box">
            <el-form :inline="true" label-width="90px" :model="handleForm" class="demo-form-inline">
                <el-form-item label="表计序列号">
                    <el-input v-model="handleForm.deviceserial" placeholder="请输入序列号"></el-input>
                </el-form-item>
                <el-form-item label="表计状态">
                    <el-select v-model="handleForm.online_status" placeholder="请选择表计状态">
                        <el-option label="全部" value="0"></el-option>
                        <el-option label="在线" value="1"></el-option>
                        <el-option label="离线" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="表计类型">
                    <el-select v-model="handleForm.devtype" placeholder="请选择表计类型">
<!--                        <el-option
                            v-for="v in baseData.devtype"
                            :key="v.value"
                            :label="v.label"
                            :value="v.value">
                        </el-option> -->
						<el-option label="温控器" value="1"></el-option>
						<el-option label="风柜" value="2"></el-option>
                    </el-select>
                </el-form-item>
               <el-form-item>
                    <el-button style="margin-left:30px;" type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div style="margin-bottom: 5px;">
            <el-button type="primary" size="small" @click="gatewayAdd" icon="el-icon-plus">添加设备</el-button>
			<el-button type="primary" size="small" @click="gatewayAddrule" icon="el-icon-plus">添加校正</el-button>
            <el-button v-if="projectsystemInfo.sys_type_id == 0? false : true" type="primary" size="small" @click="updataMeterList" icon="el-icon-plus">批量添加设备</el-button>
        </div>
        <!-- 表计列表 -->
        <l-table
            :list="tableData"
            :total="total" 
            :otherHeight="300" 
            :options="options"
            :pagination="pagination"
            :columns="columns" 
            :operates="operates"
            @handleSizeChange="handleSizeChange"
            @handleIndexChange="handleIndexChange">
        </l-table>

        <!-- 添加表计弹框 -->
        <el-dialog :title=" !addForm.oid ? '添加' : '编辑'" :visible.sync="dialogVisible" @close="handleBeforeClose">
            <el-form :model="addForm" ref="addForm" :rules="addFormRules" label-width="100px" style="margin:0 auto;width:400px;">
                <el-form-item label="表计类型" prop="devtype">
                    <el-select placeholder="请选择" size="middle" v-model="addForm.devtype" @change="handleDevTypeChange">
                        <el-option
                            v-for="v in TerminalType"
                            :key="v.value"
                            :label="v.label"
                            :value="v.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="表计序列号" prop="deviceserial">
                    <el-input v-model="addForm.deviceserial" placeholder="请输入序列号"></el-input>
                </el-form-item>
                <el-form-item label="表计名称" prop="customized_serial">
                    <el-input v-model="addForm.customized_serial" placeholder="请输入表计名称"></el-input>
                </el-form-item>
                <el-form-item label="表计型号" prop="terminal_base_id">
                    <el-select placeholder="请选择" size="middle" v-model="addForm.terminal_base_id">
                        <el-option
                            v-for="v in configMeterType"
                            :key="v.oid"
                            :label="v.device_model"
                            :value="v.oid">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备型号">
                    <el-select placeholder="请选择" size="middle" v-model="addForm.fan_model_id">
                        <el-option
                            v-for="v in deviceList"
                            :key="v.OID"
                            :label="v.label"
                            :value="v.OID">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" >
                <el-button type="primary" @click="handleSave" size="middle">确 定</el-button>
                <el-button @click="dialogVisible = false" size="middle">取 消</el-button>
            </div>
        </el-dialog>

        <!-- 选择集控器下面表计 -->
        <cmp-meter-list v-if="modalVisible" :addForm="addForm" :configMeterType="configMeterType" :modalShow.sync="modalVisible"></cmp-meter-list>
    </div>
</template>

<script>
import lTable from '@/components/lTable/lTable'
import CmpMeterList from './CmpMeterList'
import { mapGetters } from "vuex";
import Service from '@/api/Service';
import { $Alert,$Alertnew, funFmtDevType, funFmtOnlineStatus, fmtHouseInfo } from '@/utils/utils'
import { base64ToHex,hexToBase64 } from '@/utils/base64ToHex'

const defaultForm = {
    linked_collector_id: '',    //  集控器ID
    collector_serial: '',   //  集控器序列号
    devtype: '',    //  表计类型
    deviceserial: '',
    terminal_base_id: '',
    fan_model_id: '',
    customized_serial: '',
};
export default {
    name: "GatewayTable",
    inject: ["reload"],
    data() {
        return {
            // 筛选
            handleForm: {
                deviceserial: '',   
                devtype: '',   
                online_status: '0',
                OID: '',
            },
            tableData: [],
            
            dialogVisible: false,   //  添加表计浮层
            dialogEditVisible: false,
            // 添加表计表单
            addForm: JSON.parse(JSON.stringify(defaultForm)),
            addFormRules: {
                deviceserial: [{ required: true, message: '请输入序列号', trigger: 'blur' },{ min: 1, max: 100, message: '请输入1-100长度的序列号', trigger: 'blur'}],
                terminal_base_id: [{ required: true, message: '请选择表计型号', trigger: 'blur' }],
                devtype: [{ required: true, message: '请选择表计类型', trigger: 'blur' }],
                fan_model_id: [{ required: true, message: '请选择设备型号', trigger: 'blur' }],
                customized_serial: [{ required: true, message: '请输入表计序列号', trigger: 'blur' },{ min: 1, max:25, message: '请输入25长度的名称', trigger: 'blur'}]
            },

            collectorInfo: {},  //  集控器信息
            deviceList: [],     //  设备型号风盘风柜参数
            configMeterType: [],   // 设备型号 
			copy:[],//标记型号副本

             // 表格栏
            total: 0,
            pagination: {
                page_num: 1,
                page_sum: 10
            },
            columns: [
                {
                    prop: 'dev_type',
                    label: '表计类型',
                    align: 'center',
                    formatter: (row, column, cellValue) => {
                        let obj = this.TerminalType.filter(v=> { return row.dev_type === v.value})
                        if(obj.length>0) return obj[0].label;
                        return "";
                    }
                },
                {
                    prop: 'customized_serial',
                    label: '名称',
                    align: 'center',
                },
                {
                    prop: 'device_model',
                    label: '表计型号',
                    align: 'center',
                },
                {
                    prop: 'terminal_serial',
                    label: '序列号',
                    align: 'center',
                    formatter: (row, column, cellValue) => {
                        if(row['device_model'] !== 'FC109R') return `${row.terminal_serial}`
                        let base = base64ToHex(row.terminal_serial)
                        return `${row.terminal_serial}(${base})`
                    }
                },
                {
                    prop: 'collector_name',
                    label: '集控器名称',
                    align: 'center',
                    
                },
                // {
                //     prop: 'CollectorSerial',
                //     label: '集控器序列号',
                //     align: 'center',
                // },
                {
                    prop: 'assigned_house_id',
                    label: '注册状态',
                    align: 'center',
                    formatter: (row, column, cellValue) => {
                        return row.assigned_house_id > 0 ? "已注册" : "未注册";
                    }
                },
                {
                    prop: 'house_name',
                    label: '安装位置',
                    align: 'center', 
                    formatter: (row, column, cellValue) =>{
                        return fmtHouseInfo(row.house_name, row.moduleid_list);
                    }
                },
                {
                    prop: 'online_status',
                    label: '通讯状态',
                    align: 'center',
                    render: (h, params) => {
                        return h('el-tag', {
                            props: {type: params.row.online_status === 1 ? 'success' : 'danger',} // 组件的props
                        }, params.row.online_status === 1 ? '在线' : '离线')
                    }
                },
                // {
                //     prop: 'temperature',
                //     label: '绑定设备',
                //     align: 'center',
                // },
            ], // 需要展示的列
            operates: {
                width: 380,
                fixed: 'right',
                list: [
					{
					     label: '查看表计历史数据',
					     type: 'primary',
					     show: (index, row) => {
							if(row.DevType == 3 && this.projectsystemInfo.sys_type_id == 0){
								return true
							 }else{
								return false
							 }
					     },
					     plain: true,
					     disabled: (index, row) => {
							 return false
					     },
					     method: (index, row) => {
					         this.handleEditHistory(row);
					     },
					 },
                   {
                        label: '编辑',
                        type: 'primary',
                        show: (index, row) => {
                            return true
                        },
                        icon: 'el-icon-edit',
                        plain: true,
                        disabled: (index, row) => {
                            return false
                        },
                        method: (index, row) => {
                            this.handleEditMeter(row);
                        },
                    },
                    {
                        label: '删除',
                        type: 'danger',
                        show: (index, row) => {
                            return true
                        },
                        icon: 'el-icon-delete',
                        plain: true,
                        disabled: (index, row) => {
                            return false
                        },
                        method: (index, row) => {
                            this.handleDeteleMeter(row);
                        },
                    },
                ]
            }, // 操作按钮组
            options: {
                stripe: true, // 是否为斑马纹 table
                loading: false, // 是否添加表格loading加载动画
                highlightCurrentRow: true, // 是否支持当前行高亮显示
                mutiSelect: false // 是否支持列表项选中功能
            }, // table 的参数

            modalVisible: false,

            // 表计类型
            TerminalType: [],
            // 风盘参数列表
            Fancoils: [],
            // 风柜参数列表
            Fancupboard: [],
			
        };
    },
    components: { lTable, CmpMeterList },
    computed: {
        ...mapGetters(['baseData', 'projectInfo','projectsystemInfo']),
        systemType() {
            return this.projectInfo.sysid !== 2;
        }
    },
    async created() {
        this.addForm.linked_collector_id = this.$route.params.gatewayId;
        this.handleForm.OID = this.$route.params.gatewayId;
        // 获取设备型号
        this.getConfigTerminalType();
        // 设备类型
        await this.getTerminalType();

        this.getList();
        this.getCollectorInfo(this.handleForm.OID);
    },
    methods: {
        // 查询表计
        onSubmit() {
            this.getList(this.handleForm);
        },
		handleEditHistory(row){
			this.$router.push("/historyreport/" + row.OID)
		},
		//添加校正
		async gatewayAddrule(){
			let res = await Service.addRequest({collector_id:this.handleForm.OID});
			if(res == "success") {
				this.$message({
					message:"添加校正成功",
					type:"success"
				})
			}else{
				this.$message.error('添加校正失败！！！');
			}
		},
        // 获取设备型号
        async getConfigTerminalType() {
            let res = await Service.getConfigTerminalType();
            if(res) {
                res = res === 'success' ? [] : res;
                this.configMeterType = res;
				this.copy = res
            }
        },
        // 获取表计类型
        async getTerminalType() {
            this.TerminalType = await Service.getTerminalType();
        },
        // 获取在线表计列表
        async getList() {
			if(this.handleForm.deviceserial != '' && this.handleForm.deviceserial.length >= 6){
				let num = hexToBase64(this.handleForm.deviceserial)
				if(num.length == 4){
					this.handleForm.deviceserial = num
				}
			}
            let params = Object.assign({}, this.pagination, this.handleForm);
            let data = await Service.getMeter(params);
            if(data) {
                let list = data.list == null ? [] : data.list;
                this.total = data.total;
                this.tableData = list;
            }
        },
        // 获取集控器信息
        async getCollectorInfo(oid) {
            let data = await Service.getCollectorInfo({OID: oid})
            if(data) {
                this.collectorInfo = data[0];
                this.addForm.collector_serial = data[0].dev_serial;    //  集控器序列号
            }
        },

        // 编辑表计信息
        handleEditMeter(row) {
            let FanId = row.fan_model_id === 0 ? '' : row.fan_model_id
            this.addForm = {
                deviceserial: row.terminal_serial,
                oid: row.oid,
                devtype: row.dev_type,
                terminal_base_id: row.terminal_base_id,
                fan_model_id: FanId,
                collector_serial: row.collector_serial,
                customized_serial: row.customized_serial
            };
            // 配置表计型号参数
            if(row.dev_type === 1) {
                this.Fancoils.length>0 ? (this.deviceList = this.Fancoils) : this.getDeviceList(row.dev_type);
            }
            if(row.dev_type === 2) {
                this.Fancupboard.length>0 ? (this.deviceList = this.Fancoils) : this.getDeviceList(row.dev_type);
            }
            this.dialogVisible = true;
        },
        // 批量添加
        async updataMeterList() {
            this.modalVisible = true;
        },

        // 获取设备型号参数
        async getDeviceList(devtype) {
            let data,str,
                list = [];
            if(devtype === 1) {
                str = '风机盘管'
                // 获取风盘
                data = await Service.getFancoils();
                data = data === 'success' ? [] : data;
                data.map(v=>{
                    list.push({label: v.FancoilModel, OID: v.oid})
                })
                this.Fancoils = list;
            }
            if(devtype === 2) {
                str = '风柜'
                // 获取风柜
                data = await Service.getFancupboard();
                data = data === 'success' ? [] : data;
                data.map(v=>{
                    list.push({label: v.FanCupboardModel, OID: v.oid})
                })
                this.Fancupboard = list;
            }
            if(list) {
                this.deviceList = list;
            }
        },
        // 根据添加表计型号不同，获取不同参数
        async handleDevTypeChange(val) {
			if(val !== 0){
				let arr=[]
				for(var i=0;i<this.copy.length;i++){
					if(this.copy[i].devtype ==val){
						arr.push(this.copy[i])
					}
				}
				this.configMeterType=arr
				// console.log(this.configMeterType)
				arr=[]
				this.addForm.terminal_base_id =null
			}
            if(val === 1) {
                this.Fancoils.length>0 ? (this.deviceList = this.Fancoils) : this.getDeviceList(val);
				
            }else if(val === 2) {
                this.Fancupboard.length>0 ? (this.deviceList = this.Fancupboard) : this.getDeviceList(val);
            }else{
                
            }
        },

        // 添加表计
        gatewayAdd(value) {
            this.dialogVisible = true;
            this.addForm = JSON.parse(JSON.stringify(defaultForm))
            this.addForm.collector_serial = this.collectorInfo.dev_serial
            this.addForm.linked_collector_id = this.$route.params.gatewayId;
            return

            // let devtype, devTypeStr;
            // switch (value) {
            //     case "1":
            //         devtype = "1";
            //         break;
            //     case "2":
            //         devtype = "2";
            //         break;
            //     case "3":
            //         devtype = "3";
            //         break;
            // }
            
            // this.addForm.devtype = devtype;
            // this.deviceTypeList =  this.configMeterType.filter(v=> {
            //         return v.devtype == devtype
            // })
            // if(devtype !== '3'){
            //     this.getDeviceList(devtype);
            // }
            // this.dialogVisible = true;
        },
        // 
        handleBeforeClose() {
            // 重置添加表单
            this.$refs['addForm'].resetFields()
			this.getConfigTerminalType()
        },
        // 添加表计确认
        handleSave() {
            this.$refs["addForm"].validate(async (valid) => {
				// 热量表810 hm01序列号校正
                if (valid) {
					if(this.addForm.terminal_base_id == 3 || this.addForm.terminal_base_id == 1){
						var isnum = /^\d+$/.test(this.addForm.deviceserial)
						if(!isnum || this.addForm.deviceserial.length != 8){
							this.$message({
								message: '请输入正确的序列号!!!(由8位数字组成)',
								type: 'warning'
							});
							return
						}
					}
					// 温控器fw226w
					if(this.addForm.terminal_base_id == 6){
						if(this.addForm.deviceserial.length != 12){
							this.$message({
								message: '请输入正确的序列号!!!(12位长度)',
								type: 'warning'
							});
							return
						}
					}
					//温控器fc109r
					if(this.addForm.terminal_base_id == 4){
						var reg = /^[a-zA-Z0-9+\\]{4}$/.test(this.addForm.deviceserial)
						if(!reg){
							this.$message({
								message: '请输入正确的序列号!!!(4位长度 只能含有大小写字母、数字、+和\)',
								type: 'warning'
							});
							return
						}
						
					}
					//plc h3u
					if(this.addForm.terminal_base_id == 5){
						var exp=/^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/.test(this.addForm.deviceserial)
						if(!exp){
							this.$message({
								message: '请输入正确的序列号!!!(正常的ip地址)',
								type: 'warning'
							});
							return
						}
					}
                    let data
                    if(this.addForm.oid) {
                        // 编辑
                        data = await Service.editMeter(this.addForm);
                    }else {
                        // 添加
                        data = await Service.addMeter(this.addForm);
                    }
                    if(data) {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.dialogVisible = false;
                        // 更新列表
                        this.getList(this.handleForm);
                    }
                } else {
                    return false;
                }
            });
        },
        // 删除表计
        async handleDeteleMeter(row) {
            if(row.AssignedHouseID) {
                this.$notify({
                    title: '警告',
                    message: '该表计已经绑定房间，请先到表计绑定页面解除绑定。',
                    type: 'warning'
                });
                return
            }
			let data = await Service.getLastTem({terminal_id:row.oid})
			if(this.projectsystemInfo.sys_type_id != 0 || data == null || data == 'success'){
				$Alert(`确认删除${row.customized_serial}, 是否继续?`).then( async (bool)=>{
				    if(bool){
				        let data = await Service.deteleMeter({OID:row.oid});
				        if(data) {
				            this.$message({
				                type: 'success',
				                message: '删除成功!',
				            });
				            this.reload();
				        }
				    }   
				});
			}else{
				let settlementtime = data.settlement_time;
				$Alertnew(`该房间账单最近一次结算时间是${settlementtime},确认删除${row.customized_serial}, 是否继续?`).then( async (bool)=>{
				    if(bool == '1'){
				        let data = await Service.deteleMeter({OID:row.oid});
				        if(data) {
				            this.$message({
				                type: 'success',
				                message: '删除成功!',
				            });
				            this.reload();
				        }
				    }else if(bool == '0'){
							this.$router.push({path:"/readingmeter"});
						}   
				});
			}
			
            
        },
        // 关联设备
        async handleLinkDevice(row) {
            let params = {};
            params.collector_serial = row.collector_serial;
            params.deviceserial = row.terminal_serial
            params.device_model = row.device_model
            params.devtype = row.dev_type
            params.fan_model_id = row.fan_model_id

            let data = await Service.assignEdterminal(params);
            if(data) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
            }
        },
        fmtHouseStatus(row, column) {
            return row.assigned_household_id > 0 ? "已注册" : "未注册";
        },
        // 格式通讯状态
        fmtStatus(row, column) {
            return funFmtOnlineStatus(row.online_status)
        },
        // 格式化表计类型
        fmtDevType(row, column) {
            return funFmtDevType(row.dev_type);
        },
         // 切换每页显示的数量
        handleSizeChange (pagination) {
            this.pagination = pagination;
            this.getList();
        },
        // 切换页码
        handleIndexChange (pagination) {
            this.pagination = pagination;
            this.getList();
        },
    }
};
</script>

